import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useReducer } from 'react';
import { produce } from 'immer';
const DocumentReducer = (state, action) => {
    switch (action.type) {
        case 'ADD':
            return produce(state, (draft) => {
                if (action.ids) {
                    const ids = Array.isArray(action.ids) ? action.ids : [action.ids];
                    for (const id of ids) {
                        const index = draft.expandedIds.findIndex((docId) => docId === id);
                        if (index === -1) {
                            draft.expandedIds.push(id);
                        }
                    }
                }
            });
        case 'REMOVE':
            return produce(state, (draft) => {
                if (action.ids) {
                    const ids = Array.isArray(action.ids) ? action.ids : [action.ids];
                    for (const id of ids) {
                        const index = draft.expandedIds.findIndex((docId) => docId === id);
                        if (index !== -1) {
                            draft.expandedIds.splice(index, 1);
                        }
                    }
                }
            });
        case 'TOGGLE':
            return produce(state, (draft) => {
                if (action.ids) {
                    const ids = Array.isArray(action.ids) ? action.ids : [action.ids];
                    draft.expandedIds = ids;
                }
            });
        default:
            throw new Error('Invalid action');
    }
};
export const useDocumentReducer = () => useReducer(DocumentReducer, {
    expandedIds: [],
});
export const DocumentContext = createContext([{ expandedIds: [] }, () => { }]);
export const useDocumentContext = () => useContext(DocumentContext);
export const DocumentProvider = ({ children }) => {
    const [state, dispatch] = useDocumentReducer();
    return _jsx(DocumentContext.Provider, Object.assign({ value: [state, dispatch] }, { children: children }));
};
